import { render, staticRenderFns } from "./mxFileTypeEditor.vue?vue&type=template&id=c0dd207a&"
import script from "./mxFileTypeEditor.vue?vue&type=script&lang=js&"
export * from "./mxFileTypeEditor.vue?vue&type=script&lang=js&"
import style0 from "./mxFileTypeEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0dd207a')) {
      api.createRecord('c0dd207a', component.options)
    } else {
      api.reload('c0dd207a', component.options)
    }
    module.hot.accept("./mxFileTypeEditor.vue?vue&type=template&id=c0dd207a&", function () {
      api.rerender('c0dd207a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/mxFileTypeEditor.vue"
export default component.exports